import { fetch } from 'utils/api';

export function api_fetchMention(type, id) {
  return fetch({
    url: `/entities/${type}/${id}`,
    method: 'GET',
    dataType: 'Mentions'
  });
}
